import { apiEndpointToFullUrl } from 'utils/apiEndpointToFullUrl';

export const apiTokens = {
  en: {
    btnAdd: 'Create token',
    btnDelete: 'Delete',
    btnEdit: 'Edit',
    tableBoxTitle: 'API Tokens',
    pageTitle: 'API Tokens',
    noApiToken: (
      <p>Add an API Access Token to start using the IP Fabric REST API.</p>
    ),
    helpUsage: (
      <>
        <strong>How to use an API token</strong>
        <p>
          Just set <code>X-API-Token</code> into the header of API request call
        </p>
        <strong>Example</strong>
        <p>
          {typeof window !== 'undefined' && typeof URL !== 'undefined' ? (
            <code>
              curl &quot;
              {apiEndpointToFullUrl('/snapshots')}
              &quot; -H &quot;X-API-Token: YOUR-API-TOKEN&quot;
            </code>
          ) : (
            'Absolute API URL not available'
          )}
        </p>
      </>
    ),
    columns: {
      username: 'Username',
      description: 'Description',
      expiration: 'Expiration',
      lastUsed: 'Last used',
      usage: 'Usage',
      action: 'Action',
      roles: 'Roles',
    },
    never: 'Never',
    selectDate: 'Select date',
    dialogCreateHeading: 'Create new API token',
    dialogEditHeading: 'Edit API token',
    form: {
      description: 'Description',
      roles: 'Roles',
      selectRoles: 'Select roles',
      expiration: 'Expiration',
      btnCreate: 'Create',
      btnCancel: 'Cancel',
      btnSave: 'Save',
      validation: {
        required: 'Required field',
        descriptionLength: 'Must be smaller than 64',
        requireOneRole: 'At least one role is required',
      },
    },
    request: {
      created: 'API token created',
      saved: 'API token saved',
      deleted: 'API token deleted',
    },
    deleteConfirmDialog: {
      header: 'API token will be deleted',
      subHeader: 'Do you really want to delete selected API token?',
      btnConfirm: 'Delete',
      btnSecondaryConfirm: 'Cancel',
    },
    savedTokenDialog: {
      title: 'Api Token',
      warning:
        "Use this token as a password. Make sure you save it - you won't be able to access it again",
    },
  },
};
